import { render } from "./FooterNew.vue?vue&type=template&id=20e87438&scoped=true"
import script from "./FooterNew.vue?vue&type=script&lang=js"
export * from "./FooterNew.vue?vue&type=script&lang=js"

import "./FooterNew.vue?vue&type=style&index=0&id=20e87438&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e87438"]])

export default __exports__